import { GoogleMap } from "@react-google-maps/api";


enum GeolocationApiPermissionStatus {
    granted = 'granted',
    prompt = 'prompt',
    denied = 'denied',
    unknown = 'unknown',
}


const GEOLOCATION_API_OPTIONS = {
    timeout: 5000,
    maximumAge: Infinity,
};


async function getGeolocationApiPermission(): Promise<GeolocationApiPermissionStatus> {
    if (!window.navigator.permissions) return GeolocationApiPermissionStatus.unknown;
    const result = await navigator.permissions.query({ name: 'geolocation' });
    return GeolocationApiPermissionStatus[result.state];
};


export async function getCurrentLocation(
    deniedCallback?: (state: GeolocationApiPermissionStatus) => void,
): Promise<Coordinate | null> {
    const permission = await getGeolocationApiPermission();
    if (permission === GeolocationApiPermissionStatus.denied && deniedCallback) {
        deniedCallback(permission);
    };
    return await new Promise<Coordinate | null>((resolve) => {
        window.navigator.geolocation.getCurrentPosition(
            (position) => resolve({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            }),
            () => {
                if (permission === GeolocationApiPermissionStatus.unknown && deniedCallback) {
                    deniedCallback(permission);
                };
                resolve(null);
            },
            GEOLOCATION_API_OPTIONS,
        );
    });
};


export async function getLocationFromAddress(address: string): Promise<{ lat: number, lng: number }> {
    // @ts-ignore;
    const geocoder = new google.maps.Geocoder();
    return new Promise((resolve, reject) => {
        geocoder.geocode(
            { address: address, region: 'jp' },
            (res: [], status: string) => {
                if (status === 'OK') {
                    // @ts-ignore
                    const geoloc = res[0].geometry.location;
                    resolve({
                        lat: geoloc.lat(),
                        lng: geoloc.lng(),
                    });
                } else {
                    reject("入力された住所を特定できませんでした。");
                };
            },
        );
    });
};


export function checkMarkerContains(marker: Coordinate, map: GoogleMap): boolean {
    // @ts-ignore
    if (!map.getBounds()) {
        return false;
    };
    // @ts-ignore
    if (map.getBounds() === undefined) {
        return true;
    };
    // @ts-ignore
    const latlng = new window.google.maps.LatLng(marker);
    // @ts-ignore
    return map.getBounds().contains(latlng);
};


export function makeSpaceBetweenSpots(spots: Spots): Spots {
    const result = [];
    let tmp = spots;
    let isComplete = false;
    for (let i = 0; i < 49 || isComplete; i++) {
        if (tmp.length === 0) {
            isComplete = true;
            break;
        };
        const spot = tmp[0];
        const overlapSpots = tmp.filter(({ lat, lng }) => spot.lat === lat && spot.lng === lng);
        tmp.shift();
        tmp = tmp.filter(({ lat, lng }) => !(spot.lat === lat && spot.lng === lng));
        if (overlapSpots.length === 0) {
            result.push(spot);
        } else if (overlapSpots.length > 0) {
            overlapSpots.forEach((sp, i) => {
                let lat = sp.lat;
                let lng = sp.lng;
                if (i === 1) {
                    lat += 0.000015;
                    lng += 0.000015;
                } else if (i === 2) {
                    lat += 0.000015;
                    lng -= 0.000015;
                } else if (i === 3) {
                    lat -= 0.000015;
                    lng -= 0.000015;
                } else if (i === 4) {
                    lat -= 0.000015;
                    lng += 0.000015;
                } else if (i === 5) {
                    lng += 0.000015;
                } else if (i === 6) {
                    lat += 0.000015;
                } else if (i === 7) {
                    lng -= 0.000015;
                } else if (i === 8) {
                    lat -= 0.000015;
                };
                result.push({
                    ...sp,
                    lat,
                    lng,
                });
            });
        };
    };
    return result;
};


export function getDistanceBetween(a: Coordinate, b: Coordinate): number {
    const R = Math.PI / 180;
    const lat1 = a.lat * R;
    const lng1 = a.lng * R;
    const lat2 = b.lat * R;
    const lng2 = b.lng * R;
    return (6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2))) * 1000;
};
